import React from 'react';
import { useBlocker } from 'react-router-dom';
import { useUnsavedChanges } from '../contexts/UnsavedChangesContext';
import { DiscardDialogView } from '../hooks/useUnsavedGuard';

// El UNICO useBlocker de la aplicacion. React Router solo admite uno a la vez: con
// varios registrados usa el ultimo y descarta los demas, asi que un formulario sucio
// podria quedar sin proteger porque otro limpio se registro despues.
//
// Cubre la tercera puerta de salida. Las otras dos ya estaban: cerrar (el boton
// Cancelar, via useUnsavedGuard) y recargar o cerrar la pestana (beforeunload).
//
// Se le pasa una FUNCION, no un booleano: el router la llama al navegar, asi que lee
// el registro en ese instante. Con un booleano leeria el del ultimo render, y un
// gesto que guarda y navega de corrido (PlayerForm al crear) preguntaria "¿Descartar
// cambios?" despues de haber guardado bien.
const BloqueoDeSalida = () => {
  const { haySuciosAhora } = useUnsavedChanges();
  const blocker = useBlocker(haySuciosAhora);

  return (
    <DiscardDialogView
      open={blocker.state === 'blocked'}
      onSeguir={() => blocker.reset?.()}
      onDescartar={() => blocker.proceed?.()}
    />
  );
};

export default BloqueoDeSalida;
